<template>
  <div>
    <base-title
      title="Faturamento na Loja"
      :subtitle="StringLanguage.reports"
      :link="'relatorios'"
    >
      <span slot="tag" class="tag" v-if="!noPeriod"
        >{{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
        <i @click="setDefaultPeriod()" class="fal fa-times remove-filter"></i
      ></span>
      <base-button
        @click="drawers.filter.open = !drawers.filter.open"
        title="Filtrar intervalo"
        class="m_auto w-100 filter"
        :class="{ reverse: !!isMobile }"
        design="two"
      >
        <p class="filter" v-if="!isMobile">
          <i class="fal fa-calendar-day"></i>
        </p>
        <p class="filter" v-else>Filtrar intervalo</p>
      </base-button>
    </base-title>

    <div v-if="isMobile" class="relative">
      <div class="tabs mb_40">
        <ul>
          <li>
            <a
              @click="selectedTab = 0"
              :class="{ active: selectedTab === 0 }"
              >{{ StringLanguage.overview }}</a
            >
          </li>
          <li :class="{ desk: selectedTab == 1 }">
            <a
              @click="selectedTab = 1"
              :class="{ active: selectedTab === 1 }"
              >{{ StringLanguage.detailing }}</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div>
      <div class="row">
        <div
          v-if="!isMobile || selectedTab == 0"
          class="col-lg-8 col-md-12 col-xs-12 right-negative"
        >
          <div class="statistics">
            <div class="d-flex">
              <base-box class="great-numbers mr_20">
                <p>
                  {{
                    resultPeriod[0]
                      ? Utils.convertMoney(resultPeriod[0].total.toFixed(2))
                      : Utils.convertMoney(0)
                  }}
                </p>
                <p>Faturamento total</p>
              </base-box>
              <base-box class="great-numbers mr_20">
                <p>
                  {{
                    resultPeriod[0]
                      ? Utils.convertMoney(resultPeriod[0].delivery.toFixed(2))
                      : Utils.convertMoney(0)
                  }}
                </p>
                <p>Taxas de entrega</p>
              </base-box>
              <base-box class="great-numbers">
                <p>
                  {{
                    resultPeriod[0]
                      ? Utils.convertMoney(resultPeriod[0].avarage.toFixed(2))
                      : Utils.convertMoney(0)
                  }}
                </p>
                <p>Ticket médio</p>
              </base-box>
            </div>

            <div class="charts">
              <div
                class="row top-negative"
                v-if="filterType == 2 || filterType == 3"
              >
                <div class="col-xs-12 col-md-12 col-lg-12">
                  <chart-box
                    :reload-chart="reloadChart"
                    :maskMoney="true"
                    title="Fluxo de entrada"
                    :buttonLabel="filterType == 2 ? 'Trocar mês' : 'Trocar ano'"
                    :growthMonth="filterType == 2 ? secondaryDate.month : null"
                    :growthYear="
                      [2, 3].includes(+filterType) ? secondaryDate.year : null
                    "
                    :growthLabel="[2, 3].includes(+filterType) ? true : false"
                    :showChangeMonth="
                      [2, 3].includes(+filterType) ? true : false
                    "
                    @changePeriod="drawers.compare.open = !drawers.compare.open"
                    from="ordersGrowth"
                    type="line"
                    :chartData="chartMoneyData"
                    :chartOptions="chartMoneyOptions"
                    :width="300"
                    :height="300"
                    :class="isMobile ? 'mb_20' : ''"
                  />
                </div>
              </div>

              <div class="pies d-flex">
                <!-- OCB
                <base-box
                  class="pie-chart mr_20 mb_0 top-negative"
                  :class="{ 'filter-day': filterDay }"
                >
                  <base-label text="Faturamento por origem" class="mb_30" />
                  <base-chart
                    :reload="reloadChart"
                    :chartType="'doughnut'"
                    type="doughnut"
                    :chartData="chartOriginData"
                    :chartOptions="chartOriginOptions"
                    :width="300"
                    :height="300"
                  />
                </base-box>
                OCB -->

                <base-box
                  class="pie-chart mb_0 top-negative"
                  :class="{ 'filter-day': filterDay }"
                >
                  <base-label
                    text="Faturamento por formas de pagamento"
                    class="mb_30"
                  />
                  <base-chart
                    :reload="reloadChart"
                    :chartType="'doughnut'"
                    type="doughnut"
                    :chartData="chartMethodsData"
                    :chartOptions="chartMethodsOptions"
                    :width="300"
                    :height="300"
                  />
                </base-box>
              </div>
            </div>

            <base-box class="msg-charts">
              <base-message>
                Para ver os gráficos disponíveis, vire seu celular em modo
                paisagem.
              </base-message>
            </base-box>
          </div>
        </div>
        <div
          v-if="!isMobile || selectedTab == 1"
          class="col-lg-4 col-md-12 col-xs-12"
          :class="!isMobile && 'left-negative'"
        >
          <base-box
            class="payments-methods m_0"
            :class="{
              'filter-day': filterDay,
              'plus-10': !isMobile && 'plus-10',
            }"
          >
            <div class="label-origin">
              <base-label text="Detalhamento" />
            </div>

            <div class="all-methods">
              <div v-for="(oMethod, iMethod) in methods" :key="iMethod">
                <div
                  class="payment-type"
                  :class="{
                    'no-details':
                      (formatMethod(oMethod.alias).total === 0)
                      | (oMethod.method === 'Dinheiro'),
                  }"
                  @click="
                    typeof oMethod.opened !== 'undefined'
                      ? (oMethod.opened = !oMethod.opened)
                      : false
                  "
                >
                  <p class="pt-name">{{ oMethod.method }}</p>

                  <p class="pt-value">
                    <span
                      :class="{
                        mr_15:
                          typeof oMethod.opened === 'undefined' ||
                          formatMethod(oMethod.alias).total == 0,
                      }"
                      >{{
                        Utils.convertMoney(formatMethod(oMethod.alias).total)
                      }}</span
                    >
                    <span v-show="oMethod.opened === false"
                      ><i
                        class="fal fa-chevron-down ml_5"
                        v-if="formatMethod(oMethod.alias).total != 0"
                      ></i
                    ></span>
                    <span v-show="oMethod.opened === true"
                      ><i
                        class="fal fa-chevron-up ml_5"
                        v-if="formatMethod(oMethod.alias).total != 0"
                      ></i
                    ></span>
                  </p>
                </div>

                <div
                  v-show="oMethod.opened && formatMethod(oMethod.alias).methods"
                  class="payment-details"
                >
                  <div
                    v-for="(oFlag, iFlag) in formatMethod(oMethod.alias)
                      .methods"
                    :key="iFlag"
                    class="flag-box"
                  >
                    <div class="d-flex">
                      <img
                        v-if="Method[oFlag.method].alias"
                        class="mr_10"
                        :src="`https://cdn.easydelivery.com.br/cards/${
                          Method[oFlag.method].alias
                        }.png`"
                        :alt="Method[oFlag.method].alias"
                      />
                      <img
                        v-else
                        class="mr_10"
                        :src="`https://cdn.easydelivery.com.br/cards/DEFAULT.png`"
                        :alt="Method[oFlag.method].alias"
                      />
                      <p>{{ Method[oFlag.method].name }}</p>
                    </div>
                    <p>{{ Utils.convertMoney(oFlag.amount) }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="payment-type sum">
              <div class="divider" />
              <p class="pt-name">Total</p>
              <p class="pt-value">
                {{
                  resultPeriod[0]
                    ? Utils.convertMoney(resultPeriod[0].total.toFixed(2))
                    : Utils.convertMoney(0)
                }}
              </p>
            </div>
          </base-box>
        </div>
      </div>
    </div>

    <filter-period
      :open="drawers.filter.open"
      :close="drawers.filter.close"
      @filter="filterPeriod"
      :maxCustomRange="0"
    />
    <!-- <base-drawer title="Filtrar intervalo" :open="drawers.filter.open" :close="drawers.filter.close">
            <filter-period @filter="filterPeriod" />
        </base-drawer> -->

    <base-drawer
      title="Comparar fluxo de entrada"
      :open="drawers.compare.open"
      :close="drawers.compare.close"
    >
      <base-card>
        <base-label
          :text="filterType == 2 ? 'Selecione um mês' : 'Selecione um ano'"
        />

        <div class="row mt_20">
          <div class="col-lg-6 col-xs-6 col-md-6" v-if="filterType == 2">
            <base-select
              title="Mês"
              v-model="selectedSecondaryDate.month"
              class="mb_5"
            >
              <option :value="'01'">Janeiro</option>
              <option :value="'02'">Fevereiro</option>
              <option :value="'03'">Março</option>
              <option :value="'04'">Abril</option>
              <option :value="'05'">Maio</option>
              <option :value="'06'">Junho</option>
              <option :value="'07'">Julho</option>
              <option :value="'08'">Agosto</option>
              <option :value="'09'">Setembro</option>
              <option :value="'10'">Outubro</option>
              <option :value="'11'">Novembro</option>
              <option :value="'12'">Dezembro</option>
            </base-select>
          </div>
          <div
            :class="
              filterType == 2
                ? 'col-lg-6 col-xs-6 col-md-6'
                : 'col-lg-12 col-xs-12 col-md-12'
            "
          >
            <base-select
              title="Ano"
              v-model="selectedSecondaryDate.year"
              class="mb_5"
            >
              <option
                v-for="y in 10"
                :key="y"
                :value="`${parseInt(year) + 1 - y}`"
              >
                {{ parseInt(year) + 1 - y }}
              </option>
            </base-select>
          </div>
        </div>
      </base-card>

      <template v-slot:footer>
        <base-button
          :text="'Comparar'"
          @click="selectSecondaryDate()"
          class="w-100"
        />
      </template>
    </base-drawer>
  </div>
</template>
<script>
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseLabel from '@/components/Label';
import BaseDrawer from '@/components/Drawer';
import BaseCard from '@/components/Card';
import BaseSelect from '@/components/Select';
import BaseChart from '@/components/Chart.js';
import BaseMessage from '@/components/Message';

import ChartBox from '@/containers/ChartBox';

import FilterPeriod from '@/containers/FilterPeriod';

import ApiReports from '@/api/reports';

import Utils from '@/utils';
import { mapState } from 'vuex';
import { DateTime } from 'easyjs/lib/Tools';
import { Method, PaymentMethod } from 'easyjs/lib/Schema/Payment/index';
import dayjs from 'dayjs';

export default {
  components: {
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseLabel,
    BaseDrawer,
    BaseCard,
    BaseSelect,
    BaseChart,
    BaseMessage,
    FilterPeriod,
    ChartBox,
  },
  data() {
    return {
      reloadChart: false,
      noPeriod: true,
      periodSelected: '',
      filterType: 2,
      Utils,
      Method,
      DateTime,
      secondaryDate: {
        month: DateTime.format('m', new Date()),
        year: DateTime.format('Y', new Date()),
      },
      selectedSecondaryDate: {
        month: DateTime.format('m', new Date()),
        year: DateTime.format('Y', new Date()),
      },
      drawers: {
        filter: {
          open: false,
          close: false,
        },
        compare: {
          open: false,
          close: false,
        },
      },
      period: '',
      // month: DateTime.format('M', new Date()).toLowerCase(),
      month: DateTime.format('m', new Date()),
      year: DateTime.format('Y', new Date()),
      day: 20,
      hour: 10,
      final: {
        day: 1,
        days: [],
        hour: 10,
        hours: [],
      },
      filterDay: false, // Variável provisória pra simular um filtro de Dia
      compare: true,

      formatedLabel: '<%= "R$ " + value.toString().split(".").join(",") %>',

      selectedTab: 0,
      methods: [
        {
          method: 'Crédito',
          alias: 'CREDIT',
          opened: false,
          flags: [
            {
              name: 'Visa Electron',
              img: 'https://vittocdn.com.br/assets/images/admin/cards/deb_visaelectron.jpg',
              value: '0',
            },
            {
              name: 'Hipercard',
              img: 'https://vittocdn.com.br/assets/images/admin/cards/deb_hiper.jpg',
              value: '0',
            },
          ],
        },
        {
          method: 'Débito',
          opened: false,
          alias: 'DEBIT',
          flags: [
            {
              name: 'Visa Electron',
              img: 'https://vittocdn.com.br/assets/images/admin/cards/deb_visaelectron.jpg',
              value: '0',
            },
            {
              name: 'Hipercard',
              img: 'https://vittocdn.com.br/assets/images/admin/cards/deb_hiper.jpg',
              value: '0',
            },
          ],
        },
        {
          method: 'Voucher',
          opened: false,
          alias: 'VOUCHER',
          flags: [
            {
              name: 'Visa Electron',
              img: 'https://vittocdn.com.br/assets/images/admin/cards/deb_visaelectron.jpg',
              value: '0',
            },
            {
              name: 'Hipercard',
              img: 'https://vittocdn.com.br/assets/images/admin/cards/deb_hiper.jpg',
              value: '0',
            },
          ],
        },
        {
          method: 'Dinheiro',
          alias: 'MONEY',
        },
      ],
      chartOriginData: {
        labels: [],
        datasets: [
          {
            borderWidth: 0,
            backgroundColor: ['#ea527e', '#ce4568', '#ba7892'],
            data: [],
          },
        ],
      },
      chartOriginOptions: {
        cutoutPercentage: 62.5,
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 20,
            padding: 20,
          },
        },
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              const name = data.labels[tooltipItem.index].split(' ')[0];
              const value = data.datasets[0].data[tooltipItem.index];

              return value === -1
                ? ' Faturamento: R$ 0,00'
                : ` ${name}: ${value.toFormat(StringLanguage.currencyConfigs)}`;
            },
          },
        },
      },
      chartMethodsData: {
        labels: [],
        datasets: [
          {
            borderWidth: 0,
            backgroundColor: ['#ea527e', '#ce4568', '#ba7892', '#bbb'],
            data: [],
          },
        ],
      },
      chartMethodsOptions: {
        cutoutPercentage: 62.5,
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 20,
            padding: 20,
          },
        },
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              const name = data.labels[tooltipItem.index].split(' ')[0];
              const value = data.datasets[0].data[tooltipItem.index];

              return value === -1
                ? ' Faturamento: R$ 0,00'
                : ` ${name}: ${value.toFormat(StringLanguage.currencyConfigs)}`;
            },
          },
        },
      },
      chartMoneyData: {
        // MÊS
        labels: [],
        datasets: [],
      },
      datasetColors: {
        primary: {
          backgroundColor: '#FF338220',
          borderColor: '#FF3382',
          pointBackgroundColor: '#FF3382',
        },
        secundary: {
          backgroundColor: '#2E303370',
          borderColor: '#9999996B',
          pointBackgroundColor: '#999999',
        },
      },
      chartMoneyOptions: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: 'top',
          align: 'center',
          labels: {
            boxWidth: 20,
          },
        },
        elements: {
          line: {
            tension: 0,
            borderWidth: 1,
          },
        },
        scales: {
          xAxes: [
            {
              ticks: {
                maxTicksLimit: 16,
              },
              gridLines: {
                color: '#70707061',
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                callback(value) {
                  return `R$ ${value}`;
                },
                min: 0,
              },
              gridLines: {
                color: '#70707061',
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label(tooltipItem) {
              return `R$ ${Number(tooltipItem.yLabel)
                .toFixed(0)
                .replace(/./g, (c, i, a) => {
                  return i > 0 && c !== '.' && (a.length - i) % 3 === 0
                    ? `,${c}`
                    : c;
                })},00`;
            },
          },
        },
      },
      resultPeriod: [],
    };
  },
  methods: {
    formatDate(date) {
      const ds = date.split('T');
      return dayjs(dayjs(`${ds[0]} ${ds[1].split('-')[0]}`)).format(
        'HH:mm [de] DD/MM/YYYY'
      );
    },
    setDefaultPeriod() {
      const filter = {
        type: 2,
        periods: [
          `${this.year}-${this.month}-01`,
          `${this.year}-${this.month}-${DateTime.format(
            'd',
            DateTime.lastDayOfMonth(this.year, parseInt(this.month, 10) - 1)
          )} 23:59:59`,
        ],
      };

      this.filterPeriod(filter, true);
    },
    subtitle() {
      switch (parseInt(this.filterType, 10)) {
        case 1:
          return `${DateTime.format(
            'd',
            this.period.split('/')[0]
          )} de ${Utils.getMonthNames(
            parseInt(DateTime.format('m', this.period.split('/')[0]), 10)
          )} de ${DateTime.format('Y', this.period.split('/')[0])}`;
        case 2:
          return `${Utils.getMonthNames(
            parseInt(DateTime.format('m', this.period.split('/')[0]), 10)
          )} de ${DateTime.format('Y', this.period.split('/')[0])}`;
        case 3:
          return `${DateTime.format('Y', this.period.split('/')[0])}`;
        case 4:
          return `Das ${DateTime.format(
            'H',
            this.period.split('/')[0]
          )}:00 de ${DateTime.format(
            'd',
            this.period.split('/')[0]
          )}/${DateTime.format(
            'm',
            this.period.split('/')[0]
          )}/${DateTime.format(
            'Y',
            this.period.split('/')[0]
          )}, às ${DateTime.format(
            'H',
            this.period.split('/')[1]
          )}:00 de ${DateTime.format(
            'd',
            this.period.split('/')[1]
          )}/${DateTime.format(
            'm',
            this.period.split('/')[1]
          )}/${DateTime.format('Y', this.period.split('/')[1])}`;
        default:
          return '';
      }
    },
    setEndPeriod() {
      this.final.days = [];
      this.final.days.push(this.day);
      this.final.hours = [];
      let newDay = false;

      for (
        let i = parseInt(this.hour, 10) + 1;
        i <= parseInt(this.hour, 10) + 12;
        i += 1
      ) {
        let hour = i;
        newDay = false;
        if (i >= 24) {
          hour = i - 24;
          newDay = true;
        }
        this.final.hours.push({
          display: `${String(hour).padStart(2, '0')}:00`,
          value: hour,
        });
      }

      if (newDay) {
        this.final.days.push(parseInt(this.day, 10) + 1);
      }
    },
    changeTab(active) {
      this.tabActive = active;
    },
    addSecundaryDataSet(label, data, from) {
      const dataChart = [];

      let limit = -1;
      switch (parseInt(this.filterType, 10)) {
        case 2:
          limit = dayjs(from).daysInMonth();
          break;

        default:
          limit = 12;
          break;
      }

      for (let i = 1; i <= limit; i += 1) {
        dataChart.push(0);
      }

      data.stream.forEach((b) => {
        switch (parseInt(this.filterType, 10)) {
          case 2:
            dataChart[
              parseInt(dayjs(b.date).add(3, 'hours').format('D'), 10) - 1
            ] = parseFloat(b.value.toFixed(2));
            break;

          default:
            dataChart[parseInt(dayjs(b.date).format('M'), 10) - 1] = parseFloat(
              b.value.toFixed(2)
            );
            break;
        }
      });

      const newDataset = {
        label,
        backgroundColor: this.datasetColors.secundary.backgroundColor,
        borderColor: this.datasetColors.secundary.borderColor,
        pointBackgroundColor: this.datasetColors.secundary.borderColor,
        data: dataChart,
      };

      this.chartMoneyData.datasets[1] = newDataset;
      this.reloadChart = !this.reloadChart;
    },
    comparePeriod() {
      let cashdeskFilter = '';
      let filterTypeText = '';
      const startPeriod = `${this.secondaryDate.year}-${this.secondaryDate.month}-01T00:00:00-03:00Z`;
      const lastDayOfMonth = this.DateTime.format(
        'd',
        DateTime.lastDayOfMonth(
          this.secondaryDate.year,
          parseInt(this.secondaryDate.month, 10) - 1
        )
      );
      const endPeriod = `${this.secondaryDate.year}-${this.secondaryDate.month}-${lastDayOfMonth}T23:59:59-03:00Z`;

      switch (parseInt(this.filterType, 10)) {
        case 2:
          cashdeskFilter = `${startPeriod}/${endPeriod}`;
          filterTypeText = 'day';
          break;
        case 3:
          cashdeskFilter = `${this.secondaryDate.year}-01-01/${this.secondaryDate.year}-12-31`;
          filterTypeText = 'month';
          break;
        default:
          cashdeskFilter = '';
          filterTypeText = '';
          break;
      }

      const periodConf = {
        type: filterTypeText,
        periods: cashdeskFilter.split('/'),
      };
      this.getCashdeskPeriod(periodConf, true);
      this.drawers.compare.close = !this.drawers.compare.close;
    },
    getNewPeriod(period) {
      this.periodSelected = period.periods[0].join('/');
      return new Promise((resolve) => {
        this.$store.dispatch('reports/getCashdeskPeriod', period).then(() => {
          resolve(true);
        });
      });
    },
    filterPeriod(pFilter, isPeriodDefault = false) {
      const filter = pFilter;
      this.filterType = filter.type;
      this.period = filter.periods;
      this.noPeriod = !!isPeriodDefault;

      this.setSecondaryDate(filter.periods[0]);
      filter.periods[0] = dayjs(filter.periods[0]).format(
        'YYYY-MM-DDTHH:mm:ssZ[Z]'
      );
      filter.periods[1] = dayjs(filter.periods[1]).format(
        'YYYY-MM-DDTHH:mm:ssZ[Z]'
      );
      this.getCashdeskPeriod(filter);
      this.drawers.filter.close = !this.drawers.filter.close;
    },
    getCashdeskPeriod(filter, secundary = false) {
      let type = 'day';
      switch (parseInt(filter.type, 10)) {
        case 1:
          type = 'hour';
          break;
        case 2:
          type = 'day';
          break;
        case 3:
          type = 'month';
          break;
        default:
          type = 'day';
      }

      const esFilter = {
        query: [
          {
            index: 'report-orders',
            type: 'aggs',
            queries: [
              {
                match: {
                  status: 4,
                },
              },
            ],
            aggs: {
              cashdesk: {
                date_range: {
                  field: 'created_at',
                  ranges: [
                    {
                      from: filter.periods[0],
                      to: filter.periods[1],
                    },
                  ],
                },
                aggs: {
                  sales_over_time: {
                    date_histogram: {
                      field: 'created_at',
                      interval: type,
                      min_doc_count: 1,
                    },
                    aggs: {
                      total: {
                        sum: {
                          field: 'total_amount',
                        },
                      },
                    },
                  },
                  total: {
                    nested: {
                      path: 'payers',
                    },
                    aggs: {
                      total: {
                        sum: {
                          field: 'payers.amount',
                        },
                      },
                      paymentMethods: {
                        terms: {
                          field: 'payers.paymentMethod',
                        },
                        aggs: {
                          total: {
                            sum: {
                              field: 'payers.amount',
                            },
                          },
                          methods: {
                            terms: {
                              field: 'payers.method',
                            },
                            aggs: {
                              total: {
                                sum: {
                                  field: 'payers.amount',
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  origins: {
                    terms: {
                      field: 'origin',
                    },
                    aggs: {
                      total: {
                        nested: {
                          path: 'payers',
                        },
                        aggs: {
                          total: {
                            sum: {
                              field: 'payers.amount',
                            },
                          },
                        },
                      },
                    },
                  },
                  delivery: {
                    sum: {
                      field: 'delivery_amount',
                    },
                  },
                },
              },
            },
          },
        ],
      };

      ApiReports.reports(esFilter).then((response) => {
        const esResult = response.data[0].cashdesk.buckets[0];

        const paymentMethods = esResult.total.paymentMethods.buckets.map(
          (item) => {
            const methods = item.methods.buckets.map((m) => {
              return {
                method: m.key,
                amount: m.total.value,
              };
            });
            return {
              method: item.key,
              amount: item.total.value,
              methods,
            };
          }
        );


        const stream = esResult.sales_over_time.buckets.map((item) => {
          return {
            date: item.key,
            date_as_string: item.key_as_string,
            qty: item.doc_count,
            value: item.total.value,
          };
        });
        const origins = esResult.origins.buckets.map((item) => {
          return {
            origin: item.key,
            qty: item.doc_count,
            value: item.total.total.value,
          };
        });
        const formated = {
          total: esResult.total.total.value,
          orders: esResult.doc_count,
          avarage:
            esResult.total.total.value > 0
              ? esResult.total.total.value / esResult.doc_count
              : 0,
          stream,
          origins,
          delivery: esResult.delivery.value,
          paymentMethods,
          methods: [],
        };

        if (!secundary) {
          this.resultPeriod = [formated];
          this.addNewPeriod(
            [formated],
            response.data[0].cashdesk.buckets[0].from
          );
        } else {
          let name = '';
          switch (parseInt(this.filterType, 10)) {
            case 2:
              name = `${Utils.getMonthNames(
                parseInt(this.secondaryDate.month, 10)
              )}/${dayjs().year(this.secondaryDate.year).format('YY')}`;
              break;
            default:
              name = this.secondaryDate.year;
              break;
          }
          name += ` (${Utils.convertMoney(
            parseFloat(formated.total.toFixed(2))
          )})`;

          this.addSecundaryDataSet(
            name,
            formated,
            response.data[0].cashdesk.buckets[0].from
          );
        }
      });
    },
    addNewPeriod(data, from) {
      this.chartMoneyData.datasets = [];
      this.chartMoneyData.labels = [];
      let label = '';

      switch (parseInt(this.filterType, 10)) {
        case 2:
          label = dayjs(from).format('MMMM/YY');
          break;
        default:
          label = dayjs(from).format('YYYY');
          break;
      }

      const labelChart = [];
      data.forEach((item, idx) => {
        const dataChart = [];
        let limit = 12;

        switch (parseInt(this.filterType, 10)) {
          case 2:
            limit = dayjs(from).daysInMonth();
            for (let i = 1; i <= limit; i += 1) {
              if (idx === 0) labelChart.push(`Dia ${i}`);
              dataChart.push(0);
            }
            break;
          default:
            limit = 12;
            for (let i = 1; i <= limit; i += 1) {
              if (idx === 0) labelChart.push(Utils.getMonthNames(i));
              dataChart.push(0);
            }
            break;
        }

        item.stream.forEach((b) => {
          let aux = 0.0;

          switch (parseInt(this.filterType, 10)) {
            case 1:
              aux = parseFloat(
                dataChart[parseInt(dayjs(b.date).format('M'), 10)]
              );
              aux += parseFloat(b.value.toFixed(2));
              dataChart[parseInt(dayjs(b.date).format('M'), 10)] = aux;
              break;
            case 2:
              dataChart[dayjs(b.date).add(3, 'hour').format('D') - 1] =
                parseFloat(b.value.toFixed(2));
              break;
            default:
              dataChart[parseInt(dayjs(b.date).format('M'), 10)] = parseFloat(
                b.value.toFixed(2)
              );
              break;
          }
        });

        label += ` (${Utils.convertMoney(parseFloat(item.total.toFixed(2)))})`;

        const newDataset = {
          label,
          backgroundColor:
            this.chartMoneyData.datasets.length === 0
              ? this.datasetColors.primary.backgroundColor
              : this.datasetColors.secundary.backgroundColor,
          borderColor:
            this.chartMoneyData.datasets.length === 0
              ? this.datasetColors.primary.borderColor
              : this.datasetColors.secundary.borderColor,
          pointBackgroundColor: this.datasetColors.primary.borderColor,
          data: dataChart,
        };

        this.chartMoneyData.datasets.push(newDataset);
        this.chartMoneyData.labels = labelChart;

        // origins chart
        let originApp = 0;
        let originPhone = 0;
        let originDesk = 0;
        let total = 0.0;

        item.origins.forEach((a) => {
          total += parseFloat(a.value.toFixed(2));
          switch (a.origin) {
            case 1:
              originApp = parseFloat(a.value.toFixed(2));
              break;
            case 2:
              originDesk = parseFloat(a.value.toFixed(2));
              break;
            case 3:
              originPhone = parseFloat(a.value.toFixed(2));
              break;
            default:
              break;
          }
        });

        if (total === 0.0) {
          this.chartOriginData.datasets[0].data = [0, 0, -1];
        } else {
          this.chartOriginData.datasets[0].data = [
            originApp,
            originPhone,
            originDesk,
          ];
        }

        this.chartOriginData.labels = [
          `Online (${
            originApp > 0 ? Math.round((originApp * 100) / total) : 0
          }%)`,
          `Telefone (${
            originPhone > 0 ? Math.round((originPhone * 100) / total) : 0
          }%)`,
          `Balcão (${
            originDesk > 0 ? Math.round((originDesk * 100) / total) : 0
          }%)`,
        ];

        // methodsChart
        let methodCredit = 0;
        let methodDebit = 0;
        let methodVoucher = 0;
        let methodMoney = 0;
        let totalMethods = 0;

        this.methods.forEach((a) => {
          totalMethods += this.formatMethod(a.alias).total;
          switch (a.alias) {
            case 'CREDIT':
              methodCredit = this.formatMethod(a.alias).total;
              break;
            case 'DEBIT':
              methodDebit = this.formatMethod(a.alias).total;
              break;
            case 'VOUCHER':
              methodVoucher = this.formatMethod(a.alias).total;
              break;
            case 'MONEY':
              methodMoney = this.formatMethod(a.alias).total;
              break;
            default:
              break;
          }
        });

        if (parseInt(totalMethods, 10) === 0) {
          this.chartMethodsData.datasets[0].data = [0, 0, 0, -1];
          totalMethods = 1;
        } else {
          this.chartMethodsData.datasets[0].data = [
            methodCredit,
            methodDebit,
            methodVoucher,
            methodMoney,
          ];
        }

        this.chartMethodsData.labels = [
          `Crédito (${Math.round((methodCredit * 100) / totalMethods)}%)`,
          `Débito (${Math.round((methodDebit * 100) / totalMethods)}%)`,
          `Voucher (${Math.round((methodVoucher * 100) / totalMethods)}%)`,
          `Dinheiro (${Math.round((methodMoney * 100) / totalMethods)}%)`,
        ];
      });

      this.reloadChart = !this.reloadChart;
      this.comparePeriod(false);
    },
    formatMethod(method) {
      let paymentMethod = {};
      if (this.resultPeriod[0]) {
        const payment = this.resultPeriod[0].paymentMethods.filter(
          (item) =>
            (PaymentMethod[method] & item.method) >= PaymentMethod[method]
        );

        paymentMethod = {
          total:
            payment.length > 0
              ? payment.reduce((a, b) => {
                  return { amount: a.amount + b.amount };
                }).amount
              : 0,
          methods: payment.length === 1 ? payment[0].methods : [],
        };
      }

      return paymentMethod;
    },
    selectSecondaryDate() {
      const { month, year } = this.selectedSecondaryDate;
      this.secondaryDate = { month, year };

      this.comparePeriod(false);
    },
    setSecondaryDate(primaryDate = null) {
      const date = primaryDate ? new Date(primaryDate) : new Date();
      const month = date.getMonth();
      const year = date.getFullYear();

      date.setDate(1);

      if (month === 0) {
        date.setFullYear(year - 1);
        date.setMonth(11);
      } else {
        date.setMonth(month - 1);
      }

      this.secondaryDate = {
        month: DateTime.format('m', date),
        year: DateTime.format('Y', date),
      };
    },
  },

  created() {
    const filter = {
      type: 2,
      periods: [
        `${this.year}-${this.month}-01`,
        `${this.year}-${this.month}-${DateTime.format(
          'd',
          DateTime.lastDayOfMonth(this.year, parseInt(this.month, 10) - 1)
        )} 23:59:59`,
      ],
    };

    this.filterPeriod(filter, true);
    this.setSecondaryDate();
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      screenWidth: (state) => state.store.screenWidth,
      cashdesk: (state) => state.reports.cashdesk,
    }),
  },
};
</script>
<style scoped>
.tag {
  background: rgba(128, 128, 128, 0.2);
  padding: 4px 12px;
  margin-left: 10px;
  font: normal normal bold 1.2em Lato;
  color: #999;
  border-radius: 5px;
}
.remove-filter {
  margin-left: 12px;
  font-size: 13px;
  cursor: pointer;
}
.pie-chart {
  height: 333px;
  width: 100%;
}
.pie-chart.filter-day {
  height: calc(100vh - 337px);
}
.pie-chart > :nth-child(2) {
  max-height: calc(100% - 50px);
}
.payments-methods {
  height: 866px;
  position: relative;
}
.payments-methods.plus-10 {
  width: calc(100% + 10px);
}
.payments-methods.filter-day {
  height: 461px;
}
.all-methods {
  max-height: calc(100% - 70px);
  margin: 0 -15px;
  padding: 0 15px;
}

.payment-type {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2em;
  color: #f2f2f28a;
  padding: 15px 0;
  border-top: 1px solid #ffffff17;
  user-select: none;
  cursor: pointer;
}
.payment-type.no-details {
  cursor: default;
}
.paument-type.sum {
  cursor: default;
}
.payment-type:not(.sum, .no-details):hover {
  color: var(--default);
}
.payment-details:not(:empty) {
  background-color: var(--box-up);
  border-radius: 5px;
  padding: 15px 15px 0px;
  margin-bottom: 10px;
}
.payment-type.sum {
  font-weight: bold;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px 20px;
  margin: 0;
  padding: 15px;
  padding-bottom: 20px;
  font-size: 1.4em;
  line-height: 17px;
  color: #c9c9c9c7;
  border-top: none;
  cursor: default;
}
.payment-type > .divider {
  position: absolute;
  top: -5px;
  left: 15px;
  height: 2px;
  width: calc(100% - 30px);
  background: #ffffff1f;
}

.great-numbers {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding: 20px 0;
}

.great-numbers p:first-child {
  color: var(--default);
  font-size: 2.3em;
  font-weight: 900;
}

.great-numbers p:last-child {
  color: #999;
  margin-top: 15px;
  font-size: 1.2em;
}

.label-origin {
  /* border-bottom: 1px solid rgba(227, 227, 227, 0.8); */
  padding-bottom: 5px;
}

.select-origin {
  margin-bottom: 20px;
}

.flag-box {
  padding-bottom: 15px;
  font-size: 1.2em;
  color: #999;
}
.flag-box,
.flag-box > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flag-box img {
  width: 25px;
}
.compare {
  font-size: 1.6em;
  text-transform: uppercase;
  color: #999;
  font-weight: 300;
  text-align: right;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}
.compare:hover {
  color: var(--default);
}
.msg-charts {
  display: none;
}
.top-negative {
  margin-top: -10px;
}
.left-negative {
  margin-left: -10px;
}
.tabs ul li {
  display: inline;
  text-align: center;
}
.tabs a {
  cursor: pointer;
  display: inline-block;
  margin-right: 25px;
  margin-bottom: 6px;
  text-decoration: none;
  font-size: 1.4em;
  color: #999999ad;
  padding-bottom: 5px;
  border-bottom: 2px solid transparent;
}
.tabs a.active {
  color: var(--default);
  border-color: var(--default);
}

.msg-charts {
  display: none;
}

/* RESPONSIVO */
@media (max-width: 991px) {
  .pies {
    display: block;
  }
  .pie-chart:last-child {
    margin: 20px 0;
  }
  .great-numbers {
    margin-bottom: 15px;
  }
  .great-numbers p:first-child {
    font-size: 2em;
  }
  .charts {
    margin-top: 25px;
  }
  .statistics > div:first-child {
    display: block;
  }
  @media screen and (orientation: portrait) {
    .charts {
      opacity: 0;
      position: absolute;
      top: 0;
      width: 0;
      overflow: hidden;
    }
    .payments-methods {
      height: 60vh;
    }
    .msg-charts {
      display: block;
    }
  }

  @media screen and (orientation: landscape) {
    .payments-methods {
      height: 90vh;
    }
  }
}
</style>
